import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const BASE_URL = 'cosindex/api/v1/connections';
export const GET_PAGE_COUNTS_FIELD_NAME = 'pageCounts';
export const GET_PAGE_COUNTS = registerQuery({
  fieldName: GET_PAGE_COUNTS_FIELD_NAME,
  args: ['id'],
  fetcher(query) {
    if (query) {
      return http.get(`${BASE_URL}/content/children`, {
        query
      });
    }
    return http.get(`${BASE_URL}/content/children/form`);
  }
});
export function useFetchPageCounts({
  guids,
  skip
}) {
  const {
    data,
    error,
    loading
  } = useQuery(GET_PAGE_COUNTS, {
    variables: {
      id: guids
    },
    skip
  });
  return useMemo(() => ({
    data: data && data[GET_PAGE_COUNTS_FIELD_NAME],
    error,
    loading
  }), [data, error, loading]);
}